"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldIconButtonCoreInputs = void 0;
const index_1 = require("../../index");
class EmeraldIconButtonCoreInputs {
    constructor() {
        this.iconFillType = index_1.EmeraldIconType.Filled;
        this.type = index_1.EmeraldIconButtonVariant.Primary;
        this.color = index_1.EmeraldIconButtonColor.Primary;
        this.shape = index_1.EmeraldIconButtonShape.Rectangular;
        this.size = index_1.EmeraldIconButtonSize.Medium;
        this.danger = false;
        this.enableRipple = true;
        this.disabled = false;
    }
}
exports.EmeraldIconButtonCoreInputs = EmeraldIconButtonCoreInputs;
//# sourceMappingURL=icon-button.inputs.js.map